import { updateEditor } from "/WebInterface/new-ui/modules/modals/sharing/sharing.js";
import store from "/WebInterface/new-ui/store/index.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import { filesViewTypes } from "/WebInterface/new-ui/assets/js/constants.js";
import {
  sortingFields,
  sortingOrder,
} from "/WebInterface/new-ui/assets/js/constants.js";

export const applyCustomizations = (shareDialog) => {
  const { userInfo } = store;
  window.CrushFTP = window.CrushFTP || {};
  window.CrushFTP.userInfo = { ...userInfo };
  if (
    userInfo &&
    userInfo.customizations &&
    userInfo.customizations.customizations_subitem
  ) {
    const options = userInfo.customizations.customizations_subitem;
    if (options) {
      if (shareDialog) {
        applyUserCustomizationsInShareWindow(options, shareDialog);
      } else {
        applyUserCustomizations(options);
      }
    }
  }
};

const applyUserCustomizationsInShareWindow = (customizations, shareDialog) => {
  customizations?.forEach((curItem) => {
    const value = curItem.value;
    const shareDialogFind = (selector) => shareDialog.find(selector);

    switch (curItem.key) {
      case "EXPIREDAYS":
        shareDialogFind("#txtdays").val(value);
        break;
      case "EXPIREDAYSMAX":
        // Todo
        break;
      case "SENDEMAILDEFAULT":
        shareDialogFind("#sendEmail", true).checked = value === "true";
        break;
      case "SHAREMETHOD":
        shareDialogFind("#internalShare", true).checked = value === "internal";
        shareDialogFind("#externalShare", true).checked = value !== "internal";
        break;
      case "EMAILFROM":
        shareDialogFind("#emailFrom").val(value);
        break;
      case "EMAILTO":
        shareDialogFind("#emailTo").val(value);
        break;
      case "EMAILCC":
        shareDialogFind("#emailCc").val(value);
        break;
      case "EMAILBCC":
        shareDialogFind("#emailBcc").val(value);
        break;
      case "EMAILREPLYTO":
        shareDialogFind("#emailReplyTo").val(value);
        break;
      case "EMAILSUBJECT":
        shareDialogFind("#emailSubject").val(value);
        break;
      case "EMAILBODY":
        const curValue = value.replace(/\\r/g, "\r").replace(/\\n/g, "\n");
        const emailVal = curValue;
        const curVal = emailVal;
        const nameBodySeparator = "``````";
        const templateSeparator = "^^^^^^";
        const _templates = curVal || "";
        const templates = _templates.split(templateSeparator);
        const curTemplates = [];

        for (let i = 0; i < templates.length; i++) {
          const splits = templates[i].split(nameBodySeparator);
          const [name = "Default", body] = splits;
          const isDefault = name.endsWith("_default");
          curTemplates.push({
            name: isDefault ? name.slice(0, -8) : name,
            body,
            isDefault,
          });
        }

        if (curTemplates.length > 1) {
          shareDialogFind("#emailBodyTemplatePanel").removeClass("is-hidden");
        }

        const templatesKeyVal = {};
        const emailBodyTemplate = shareDialogFind("#emailBodyTemplate");

        for (let i = 0; i < curTemplates.length; i++) {
          const cur = curTemplates[i];
          const checked = cur.isDefault ? "selected='selected' " : "";
          const val = `${cur.name}_${i}`;
          const elem = `<option value="${val}" ${checked}>${cur.name}</option>`;
          templatesKeyVal[val] = cur;
          emailBodyTemplate.append(elem);
        }

        const trigger = () => {
          if (emailBodyTemplate && emailBodyTemplate.length === 0) return;
          const selectedOption = emailBodyTemplate.val();
          updateEditor(templatesKeyVal[selectedOption]?.body);
        };

        emailBodyTemplate.on("change", trigger);
        trigger();
        break;
      default:
        break;
    }
  });
};

export const applyDefaultUserCustomizationOption = (item) => {
  if (!item) return;

  const { key, value } = item;

  switch (key) {
    case "logo":
      let logoLink = value;
      if (
        !logoLink.toLowerCase().startsWith("http://") &&
        !logoLink.toLowerCase().startsWith("https://")
      ) {
        logoLink = `/WebInterface/images/${logoLink}`;
      }

      const logoElement = _$("w-image.logo");
      for (let i = 0; i < logoElement.length; i++) {
        const el = logoElement[i];
        el.src = logoLink;
      }
      break;

    case "linkOnLogo":
      const link = value;
      if (link) {
        const logoElement = _$("#dashboard-header #logo-container");
        const parentElement = logoElement.parent();

        if (!parentElement.attr("href")) {
          const logo = logoElement.el();
          const wrapper =
            link === "#"
              ? _$("<a href='" + link + "'></a>")
              : _$("<a target='_blank' href='" + link + "'></a>");
          wrapper.append(logo);
          logo.parentNode.replaceChild(wrapper, logo);
        } else {
          parentElement.attr("href", link);
        }

        if (window.logoLinkTarget) {
          parentElement.attr("target", window.logoLinkTarget);
        }

        logoElement.find("img").css("border", "none");
      }
      break;

    case "linkTargetOnLogo":
      const linkTarget = value;
      if (linkTarget) {
        const logoElement = _$("#dashboard-header #logo-container");
        const parentElement = logoElement.parent();

        if (parentElement.attr("href")) {
          parentElement.attr("target", linkTarget);
        }
      }
      break;

    case "title":
      if (!window.hasLocalTitle) {
        document.title = value;
        try {
          pageTitleNotification.vars.OriginalTitle = value;
        } catch (ex) {}
      }
      break;

    case "slideshowWindowTitle":
      if (window.forSlideshow) {
        document.title = value;
      }
      break;

    case "autoRefreshListingTime":
      if (value) {
        const autoRefreshListingTime = parseInt(value);
        if (!isNaN(autoRefreshListingTime)) {
          setInterval(() => {
            store.dispatch("refreshListing");
          }, autoRefreshListingTime * 1000);
        }
      }
      break;

    case "listDefaultView":
      const listingLayoutView = value;
      if (listingLayoutView) {
        if (listingLayoutView === "treeview") {
          utils.storage.set("activeView", filesViewTypes.LIST);
        } else {
          utils.storage.set("activeView", filesViewTypes.GRID);
        }
      }
      break;

    case "basket_DefaultView":
      const basketLayoutView = value;
      if (basketLayoutView === "treeview") {
        store.dispatch("handleChangeBasketView", filesViewTypes.LIST);
      } else {
        store.dispatch("handleChangeBasketView", filesViewTypes.MEDIUM_GRID);
      }
      break;

    case "showLanguageSelection":
      if (value === "true" || value === true) {
        _$("w-language").removeClass("is-hidden");
      }
      break;

    case "default-theme":
      if (value === "dark") {
        _$("[data-theme]").attr("data-theme", "dark");
        localStorage.setItem("data-theme", "dark");
      } else if (value === "light") {
        _$("[data-theme]").attr("data-theme", "light");
        localStorage.setItem("data-theme", "light");
      }
      break;

    case "hide-theme-picker":
      if (value === "true") {
        _$("w-theme").remove();
      }
      break;

    case "hide-basket-icon":
      if (value === "true") {
        _$("#basket_icon").remove();
      }
      break;

    case "hideUserNameFromHeader":
      if (value === "true") {
        _$("#logged-in-details-dropdown").remove();
      }
      break;

    case "showHeaderTextInCenterOfTopBar":
      if (value === "true") {
        const logoAlign = utils.getUserCustomizationValue("logoAlign", true);

        const headerTextSection = _$("#header-text-section").addClass(
          "is-hidden"
        );
        const headerTextSection2 = _$("#header-text-section2").addClass(
          "is-hidden"
        );
        const headerTextSection3 = _$("#header-text-section3").addClass(
          "is-hidden"
        );

        if (logoAlign) {
          if (logoAlign === "middle") {
            headerTextSection
              .removeClass("is-hidden")
              .addClass("has-text-centered");
          } else if (logoAlign === "right") {
            headerTextSection3.removeClass("is-hidden");
          } else {
            headerTextSection2.removeClass("is-hidden");
          }
        } else {
          headerTextSection2.removeClass("is-hidden");
        }
      }
      break;

    case "copyrightText":
      _$("#copyright").html(utils.sanitizePure(value));
      break;

    case "poweredbyText":
      _$("#poweredBy").html(utils.sanitizePure(value));
      break;

    case "showOnlyTheseLanguages":
      utils.filterLanguagesToShow(value);
      break;

    case "header":
      const sanitizedHeaderHtml = utils.sanitizePure(value);
      const headerTextSection2 = _$("#header-text-section2").el();
      const headerTextSection3 = _$("#header-text-section3").el();
      if (headerTextSection2) {
        headerTextSection2.innerHTML = sanitizedHeaderHtml;
      }
      if (headerTextSection3) {
        headerTextSection3.innerHTML = sanitizedHeaderHtml;
      }

      const headerText = _$("#header-text-section");
      if (headerText.el()) {
        headerText.el().innerHTML = sanitizedHeaderHtml;
      }

      const showHeaderTextInCenterOfTopBar = utils.getUserCustomizationValue(
        "showHeaderTextInCenterOfTopBar"
      );
      if (!showHeaderTextInCenterOfTopBar) {
        headerText.removeClass("is-hidden");
      }
      break;

    case "headerTextSize":
      _$("#header-text-section").css("fontSize", value);
      _$("#header-text-section2").css("fontSize", value);
      _$("#header-text-section3").css("fontSize", value);
      break;

    case "headerTextStyle":
      const cssPropertyForHeader =
        value === "bold" ? "fontWeight" : "fontStyle";
      _$("#header-text-section").css(cssPropertyForHeader, value);
      _$("#header-text-section2").css(cssPropertyForHeader, value);
      _$("#header-text-section3").css(cssPropertyForHeader, value);
      break;

    case "logoAlign":
      if (value === "right") {
        _$("#dashboard-header #header-content").removeClass("is-flex-grow-1");

        _$("#dashboard-header #left-logo")
          .removeClass("is-flex")
          .addClass("is-hidden");

        _$("#dashboard-header #right-logo")
          .removeClass("is-hidden")
          .addClass("is-flex");
      }
      if (value === "middle") {
        _$("#dashboard-header #logo-container")
          .parent()
          .addClass("centered-element");
      }
      break;

    case "maxFileNameLengthInUpload":
      if (value) {
        window.maxFileNameLengthInUpload = parseInt(value);
      }
      break;

    case "hideStartButtonOnIndividualUploadItem":
      if (value === "true") {
        window.hideStartButtonOnIndividualUploadItem = true;
      }
      break;

    case "autoRemoveUploadedItemFromList":
      if (value === "true") {
        window.autoRemoveUploadedItemFromList = true;
      }
      break;

    case "autoUploadFlag":
      if (value === "true") {
        const userOptions = {
          ...store.userOptions,
          preference: {
            ...store.userOptions.preference,
            autoStartUpload: true,
          },
        };
        store.dispatch("setUserOptions", userOptions);
      }
      break;

    case "upload_hideUploadBarAfterUpload":
      if (value === "true") {
        window.hideUploadBarAfterUpload = true;
      }
      break;

    case "blockUploadingDirs":
      window.blockUploadingDirs = value.toLowerCase() === "true";
      break;

    case "upload_MaxFileSizeInMB":
      if (!isNaN(value)) {
        window.maxFileSizeAllowed = parseInt(value);
      }
      break;

    case "onlyAllowedExtensionsToUpload":
      if (value && value.length > 0) {
        const exts = value
          .toLowerCase()
          .split(",")
          .filter((ext) => ext.trim() !== "");
        window.onlyAllowedExtensionsToUpload = exts;
      }
      break;

    case "notAllowedExtensionsToUpload":
      if (value && value.length > 0) {
        const exts = value
          .toLowerCase()
          .split(",")
          .filter((ext) => ext.trim() !== "");
        window.notAllowedExtensionsToUpload = exts;
      }
      break;

    case "uploadWindowShowNameInsteadOfFullPath":
      if (value === "true") {
        window.uploadWindowShowNameInsteadOfFullPath = true;
      }
      break;

    case "autoRenameFilesWhileUploading":
      if (value === "true") {
        window.autoRenameFilesWhileUploading = true;
      }
      break;

    case "autoRenameFilesWhileUploadingCrushDrop":
      if (value === "true") {
        window.autoRenameFilesWhileUploadingCrushDrop = true;
      }
      break;

    case "groupShareFiles":
      if (value === "true") {
        window.groupShareFiles = true;
      }
      break;

    case "groupShareFilesCrushDrop":
      if (value === "true") {
        window.groupShareFilesCrushDrop = true;
      }
      break;

    case "autoStartMediaPlaybackInPreview":
      if (value === "true") {
        store.dispatch("setUserCustomization", {
          type: "autoStartMediaPlaybackInPreview",
          value: true,
        });
      }
      break;

    case "listDefaultSortColumnIndex":
      const sortingStatus =
        JSON.parse(localStorage.getItem("sortingStatus")) || {};
      let sortingField;

      if (value === "1") {
        sortingField = sortingStatus.active = sortingFields.NAME;
      } else if (value === "2") {
        sortingField = sortingStatus.active = sortingFields.SIZE;
      } else if (value === "3") {
        sortingField = sortingStatus.active = sortingFields.LAST_MODIFIED;
      } else {
        return;
      }

      sortingStatus[sortingField] = sortingOrder.ASC;
      localStorage.setItem("sortingStatus", JSON.stringify(sortingStatus));
      break;

    case "listDefaultSortDirection":
      const sortingStatusForSortDirection = JSON.parse(
        localStorage.getItem("sortingStatus")
      );

      if (!sortingStatusForSortDirection) return;

      const activeField = sortingStatusForSortDirection.active;

      if (value === "up") {
        sortingStatusForSortDirection[activeField] = sortingOrder.ASC;
      } else if (value === "down") {
        sortingStatusForSortDirection[activeField] = sortingOrder.DES;
      } else {
        return;
      }

      localStorage.setItem(
        "sortingStatus",
        JSON.stringify(sortingStatusForSortDirection)
      );
      break;

    case "OPEN_NEW_WINDOW_EXTENSIONS": // Pending
      const extension = value.split(",");
      store.dispatch("setUserCustomization", {
        type: "OPEN_NEW_WINDOW_EXTENSIONS",
        value: extension,
      });
      break;

    case "footer":
      //Footer html
      if (
        _$("#footerContent").sel().length > 0 &&
        value &&
        typeof value === "string"
      ) {
        const footerContent = _$("#footerContent");
        footerContent.removeClass("is-hidden");
        const footerEl = footerContent.el();
        if (footerEl) {
          footerEl.innerHTML = utils.sanitizePure(value);
        }
      }
      break;

    case "footerBackgroundColor":
      //Footer background color
      _$("#footerContent").css("backgroundColor", value);
      break;

    case "keepTopBarButtonsOnSmallerScreen":
      _$(".dashboard-section .hamburger-menu-container").addClass("is-hidden");
      _$(".dashboard-section .user-buttons-section").addClass("top-bar-button");
      break;

    case "backgroundOfButtons":
      if (value === "true") {
        // NOTE: document.createElement("style") violates CSP policy style-src 'self'
        // This dynamically creates styles for button backgrounds based on user customization.
        // For full CSP compliance, consider using CSS classes with data attributes or a different theming approach.
        const style = document.createElement("style");
        style.textContent = `
          .dashboard-section .user-buttons-section .user-buttons-item .navbar-item-label {
            background-color: var(--accent-background-secondary);
          }
          .dashboard-section .user-buttons-section .user-buttons-item .navbar-item-label:hover, .breadcrumb li a:hover * {
            color: var(--text-primary);
            opacity: 0.8;
          }
        `;
        document.head.appendChild(style);
      }
      break;

    case "hideDirectoryInfo":
      if (value === "true") {
        _$("#currentDirectoryInfo").html("");
      }
      break;

    case "hideNotificationBell":
      if (value === "true") {
        const activityDropdown = _$("#activity-dropdown");
        if (activityDropdown.length > 0) {
          activityDropdown.addClass("is-hidden");
        }
      }
      break;

    case "fileCountPosition":
      const currentDirectoryInfo = document.getElementById(
        "currentDirectoryInfo"
      );
      const filterContainer = document.getElementById(
        "dashboard-filter-container"
      );
      const footerContainer = document.querySelector(
        "#dashboard-footer .footer-container"
      );

      if (!currentDirectoryInfo) return;

      if (value === "top" && filterContainer) {
        if (currentDirectoryInfo.parentNode !== filterContainer.parentNode) {
          currentDirectoryInfo.classList.add(
            "px-3",
            "pb-2",
            "text-sm",
            "w-full"
          );
          filterContainer.parentNode.insertBefore(
            currentDirectoryInfo,
            filterContainer.nextSibling
          );
          if (footerContainer) {
            footerContainer.classList.add("is-justify-content-end");
            footerContainer.classList.remove(
              "is-justify-content-space-between"
            );
          }
        }
      } else if (footerContainer) {
        if (currentDirectoryInfo.parentNode !== footerContainer) {
          currentDirectoryInfo.classList.remove(
            "px-3",
            "pb-2",
            "text-sm",
            "w-full"
          );
          footerContainer.insertBefore(
            currentDirectoryInfo,
            footerContainer.firstChild
          );
          footerContainer.classList.add("is-justify-content-space-between");
          footerContainer.classList.remove("is-justify-content-end");
        }
      }
      break;

    default:
      break;
  }
};

export const applyUserCustomizationOption = (item) => {
  if (!item) return;

  const { key, value } = item;

  switch (key) {
    case "hideFilterPanel":
      // Hide filter
      if (value === "true") {
        const hideFilterSectionWrapper = _$("#hideFilterSectionWrapper");
        if (hideFilterSectionWrapper.length > 0) {
          hideFilterSectionWrapper.addClass("is-hidden");
        }

        const filterInputContainer = _$(".filter-sorting-section").find(
          ".filter-input-wrapper"
        );
        const searchAndFilterDivider = _$(".filter-sorting-section").find(
          "#searchAndFilterDivider"
        );

        if (filterInputContainer && searchAndFilterDivider) {
          filterInputContainer.remove();
          searchAndFilterDivider.remove();
        }
      }
      break;
    case "autoNavigateToFolderOnCreation":
      if (value === "true") {
        _$("#navigateToFolderOnCreate").attr("checked", "true");
      }
      break;
    case "NAME_COL_TEXT":
    case "SIZE_COL_TEXT":
    case "MODIFIED_COL_TEXT":
    case "KEYWORDS_COL_TEXT":
    case "CREATED_COL_TEXT":
      const sortList = _$(`#dashboard-${key.toLowerCase()}-sort-list`).find(
        "span"
      );
      if (sortList) {
        sortList.attr("data-i18n-key", value);
        sortList.text(value);
      }
      break;
    case "basket_NoViewChange":
      if (value === "true") {
        _$("#basket-file-view-dropdown").remove();
      }
      break;
    case "basket_HideFilter":
      if (value === "true") {
        _$(
          "#basket-filter-container .filter-sorting-section .filter-input-wrapper"
        ).remove();
      }
      break;
    case "basket_HideDownload":
      if (value === "true") {
        _$("#modal_UI_Basket .download-basket-button").remove();
      }
      break;
    case "basket_HideShare":
      if (value === "true") {
        _$("#modal_UI_Basket .share-basket-button").remove();
      }
      break;
    case "listHeaderTextStyle":
      const listViewTHead = _$(
        `#dashboard-files-section .list-container thead`
      );
      if (listViewTHead.el()) {
        const th = listViewTHead.find("tr th");
        const cssProperty = value === "bold" ? "font-weight" : "font-style";
        th.css(null, null, `${cssProperty}:${value}`);
      }
      break;
    case "listHeaderTextSize":
      const listViewTHeadForSize = _$(
        `#dashboard-files-section .list-container thead`
      );
      if (listViewTHeadForSize.el()) {
        const th = listViewTHeadForSize.find("tr th span");
        th.css(null, null, `font-size:${value}`);
      }
      break;
    case "pathTextSize":
      _$("#dashboard-breadcrumb span.directory-name").css("fontSize", value);
      break;
    case "pathTextStyle":
      const cssProperty = value === "bold" ? "fontWeight" : "fontStyle";
      _$("#dashboard-breadcrumb ul li a span.directory-name").css(
        cssProperty,
        value
      );
    case "hideSelectionLink":
      if (value === "true") {
        _$("#dashboard-filter-select-dropdown").remove();
      }
      break;
    case "hideViewSelector":
      if (value === "true") {
        _$("#dashboard-file-view-dropdown").remove();
      }
      break;
    default:
      break;
  }
};

const applyUserCustomizations = (customizations) => {
  _$("w-language").addClass("is-hidden");

  if (!customizations.forEach) {
    customizations = [
      { key: customizations?.key, value: customizations?.value },
    ];
  }

  customizations.forEach((curItem) => {
    applyDefaultUserCustomizationOption(curItem);
  });
};
